import type { FunctionComponent } from "react"

import Skeleton from "react-loading-skeleton"

import { ElementGrid } from "@jobteaser/ui-kit/components/ElementGrid/ElementGrid"

import styles from "./ArticlesListing.module.css"

const ARTICLES_NUMBER = 8
const ARTICLES_HEIGHT = 400

export const ArticlesLoading: FunctionComponent = () => {
  return (
    <ElementGrid className={styles.articlesWrapper}>
      {Array(ARTICLES_NUMBER)
        .fill(undefined)
        .map((_item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton height={ARTICLES_HEIGHT} key={index} />
        ))}
    </ElementGrid>
  )
}
